import { LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js';
import { useQuery } from '@tanstack/react-query';

import { connection } from '@/constants/solana';
import { useAuthenticatedWallet } from '@/hooks/ui/use-authenticated-wallet';

export const useSolanaBalance = (address?: PublicKey) => {
  const { publicKey } = useAuthenticatedWallet();

  const key = address || publicKey;
  return useQuery({
    queryKey: ['solana-balance', key],
    refetchInterval: 60 * 1000,
    queryFn: async () => {
      try {
        if (!key) return { amount: 0, uiAmount: 0 };

        const balance = await connection.getBalance(key);

        return { amount: balance, uiAmount: balance / LAMPORTS_PER_SOL };
      } catch (error) {
        console.log(error);
        return { amount: 0, uiAmount: 0 };
      }
    },
  });
};
